import React, { useEffect, useContext } from 'react'
import { Content, RightSide, StructureContainer, Title, ButtonDiv, Button, StructureHeader, AllowFilesDiv } from '../CreateCertificate/style'
import ManageStructures from './ManageStructures'
import ParamMainFields from './ParamMainFields'
import { ColumnType } from '../../../../components/Modals/EditStructure'
import { useNavigate, useOutletContext, useSearchParams } from 'react-router-dom'
import { CertificateOutletType } from '..'
import StructureColumns, { isMinGreaterThanMax } from './StructureColumns'
import saveImage from '../../../../assets/certificates/AddParameter/save.svg'
import axios from '../../../../config/axios'
import { SwitchBox, SwitchInput, SwitchSlider } from '../../Accesses/ProfilesTable/style'
import { FeedbackContext } from '../../../../contexts/FeedbackContext'

export interface StructureType {
  id: number
  name: string
  columns: ColumnType[]
}

export interface ParamStructureItem {
  id?: number | string
  name: string
  min?: number | null
  max?: number | null
  unit?: string
}

export interface ParamType {
  id?: number
  structures: StructureType[]
  type?: { id: number; name: string }
  certificateType?: string
  CertificateType?: { id: number; name: string }
  certificateTypeId?: number
  name?: string
  class?: string
  family?: string
  astm?: string
  uns?: string
  din?: string
  aisi?: string
  others?: string
  mechanicalTests?: ParamStructureItem[]
  chemicalComposition?: ParamStructureItem[]
}

const CreateParam = () => {
  const { setParam, param, setLoading } = useOutletContext<CertificateOutletType>()
  const { setFeedback } = useContext(FeedbackContext)
  const [ searchParams ] = useSearchParams()
  const navigate = useNavigate()
  const id = searchParams.get('id')
  const duplicateFrom = searchParams.get('duplicateFrom')
  
  useEffect(() => {
    const sourceId = id || duplicateFrom
    if(sourceId) {
      setLoading(true)
      axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/certificates/param/${sourceId}`)
        .then(response => {
          if(response.data) {
            if (duplicateFrom && !id) {
              const { id: _sourceId, ...rest } = response.data
              setParam({
                ...rest,
                name: `${rest.name || ''} - cópia`.replace(/^\s+/, ''),
              })
            } else {
              setParam(response.data)
            }
          }
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }, [])
  
  const handleCreateOrEditParam = () => {
    for (const structure of param.structures) {
      for (const column of structure.columns) {
        if (isMinGreaterThanMax(column.min, column.max)) {
          setFeedback({
            isOpen: true,
            message: `O valor mínimo (${column.min}) não pode ser maior que o valor máximo (${column.max}) na coluna "${column.name}".`,
            statusOk: false,
          })
          return
        }
      }
    }

    const {id, type, ...data} = param
    setLoading(true)
    if(id) {
      axios.put(`${process.env.REACT_APP_GATEWAY_BASE_URL}/certificates/param/${id}`, {...data, certificateTypeId: type?.id})
        .then(() => {
          navigate('/panel/certificates/params')
        })
        .catch(error => {
          const errorMessage = error?.response?.data?.message || 'Erro ao salvar parâmetro.'
          setFeedback({
            isOpen: true,
            message: Array.isArray(errorMessage) ? errorMessage.join('; ') : errorMessage,
            statusOk: false,
          })
          console.error(error)
        })
        .finally(() => {
          setLoading(false)
        })
      return
    }
    axios.post(`${process.env.REACT_APP_GATEWAY_BASE_URL}/certificates/param/`, {...data, certificateTypeId: type?.id})
      .then(() => {
        navigate('/panel/certificates/params')
      })
      .catch(error => {
        const errorMessage = error?.response?.data?.message || 'Erro ao criar parâmetro.'
        setFeedback({
          isOpen: true,
          message: Array.isArray(errorMessage) ? errorMessage.join('; ') : errorMessage,
          statusOk: false,
        })
        console.error(error)
      })
      .finally(() => {
        setLoading(false)
      })
    return
  }

  return (
    <>
      <Content>
        <ManageStructures setParam={setParam} param={param} />
        <RightSide>
          <ParamMainFields param={param} setParam={setParam} />
          {param.structures.map((structure, index) => 
            <StructureContainer key={index}>
              <StructureHeader>
                <Title>{structure.name}</Title>
              </StructureHeader>
              {structure.columns.length > 0 && <StructureColumns structureIndex={index} />}
            </StructureContainer>
          )}
        </RightSide>
        <ButtonDiv>
          <Button onClick={() => navigate('/panel/certificates/params')}>Cancelar</Button>
          <Button onClick={handleCreateOrEditParam} isSave={true}> <img src={saveImage} /> Salvar parâmetro</Button>
        </ButtonDiv>
      </Content>
    </>
  )
}

export default CreateParam